// What a group calls each of its roles.  Groups can rename Student and Teacher
// (e.g. Learner / Coach); Observer has no custom name.

import { BasePeerGroup, MemberRole } from '@/models';

export type GroupRoleFilter = MemberRole | 'ALL';

type RoleNames = Pick<
  BasePeerGroup,
  | 'roleNameStudent'
  | 'roleNameStudentPlural'
  | 'roleNameTeacher'
  | 'roleNameTeacherPlural'
>;

const DEFAULT_NAMES: { [role in MemberRole]: [string, string] } = {
  [MemberRole.STUDENT]: ['student', 'students'],
  [MemberRole.TEACHER]: ['teacher', 'teachers'],
  [MemberRole.OBSERVER]: ['observer', 'observers']
};

const customNames = (
  role: MemberRole,
  peerGroup: RoleNames
): [string | undefined, string | undefined] => {
  switch (role) {
    case MemberRole.STUDENT:
      return [peerGroup.roleNameStudent, peerGroup.roleNameStudentPlural];
    case MemberRole.TEACHER:
      return [peerGroup.roleNameTeacher, peerGroup.roleNameTeacherPlural];
    case MemberRole.OBSERVER:
      return [undefined, undefined];
  }
};

/** The group's name for `role`, falling back to the default when blank. */
export const groupRoleName = (role: MemberRole, peerGroup: RoleNames): string =>
  customNames(role, peerGroup)[0] || DEFAULT_NAMES[role][0];

/** The group's plural for `role`, falling back to the default when blank. */
export const groupRolePlural = (
  role: MemberRole,
  peerGroup: RoleNames
): string => customNames(role, peerGroup)[1] || DEFAULT_NAMES[role][1];
